import { render, staticRenderFns } from "./nfcManuallyAccess.vue?vue&type=template&id=28641deb&"
import script from "./nfcManuallyAccess.vue?vue&type=script&lang=js&"
export * from "./nfcManuallyAccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports